import React from "react";
import {about} from "../portfolio";
import Reveal from "./Reveal";

export default function About() {
  return (
    <section className="fx-section" id="profile">
      <div className="fx-container">
        <Reveal>
          <div className="fx-eyebrow">01 · Profile</div>
        </Reveal>
        <Reveal delay={100}>
          <p className="fx-about-statement">
            {about.statement.split(" — ")[0]} —{" "}
            <strong>{about.statement.split(" — ")[1]}</strong>
          </p>
        </Reveal>
        <div className="fx-about-grid">
          <Reveal delay={150}>
            <div>
              {about.paragraphs.map((p, i) => (
                <p key={i}>{p}</p>
              ))}
            </div>
          </Reveal>
          <Reveal delay={250}>
            <div className="fx-facts">
              {about.facts.map(f => (
                <div className="fx-fact" key={f.label}>
                  <span className="f-label">{f.label}</span>
                  <span className="f-value">{f.value}</span>
                </div>
              ))}
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
